import React, { ChangeEvent } from "react";

import { useCheckPasswordStrength, useTranslation } from "utils";

import { USER_TITLE } from "consts";

import { Checkbox, Col, Form, Input, InputPassword, KlimRadioGroup, PasswordStrengthPopup, Row } from "components";

export const ConfirmAccountStep1 = () => {
  const { t } = useTranslation(["signinup", "meta", "enums"]);
  const { setPasswordMatch, setPasswordStrength, currentPasswordStrength } = useCheckPasswordStrength();

  const handlePasswordChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPasswordStrength(e);
  };

  const handleConfirmPasswordChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPasswordMatch(e);
  };

  return (
    <>
      <Row>
        <Col>
          <h2>{t("confirm.personalData")}</h2>
          <p className="margin-top-125">{t("confirm.personalDataDescription")}</p>
        </Col>
      </Row>
      <Row className="margin-top-250">
        <Col sm={24} md={24}>
          <Form.Item name="title" rules={[{ required: true }]}>
            <KlimRadioGroup
              dataTestId="singup-title-label"
              options={[
                { label: t(`confirm.inputs.title.${USER_TITLE.MR}`), value: USER_TITLE.MR },
                { label: t(`confirm.inputs.title.${USER_TITLE.MRS}`), value: USER_TITLE.MRS },
                { label: t(`confirm.inputs.title.${USER_TITLE.OTHER}`), value: USER_TITLE.OTHER },
              ]}
            />
          </Form.Item>
        </Col>
        <Col sm={24} md={24}>
          <Input name="firstName" label={t("confirm.inputs.firstName")} rules={[{ required: true }]} />
        </Col>
        <Col sm={24} md={24}>
          <Input name="lastName" label={t("confirm.inputs.lastName")} rules={[{ required: true }]} />
        </Col>
      </Row>
      <Row>
        <Col sm={24} md={24}>
          <InputPassword
            name="password"
            label={t("confirm.inputs.password")}
            rules={[{ required: true }]}
            PasswordStrengthPopup={<PasswordStrengthPopup currentPasswordStrength={currentPasswordStrength} />}
            onChange={(e: ChangeEvent<HTMLInputElement>) => handlePasswordChange(e)}
          />
        </Col>
        <Col sm={24} md={24}>
          <InputPassword
            name="confirmPassword"
            label={t("confirm.inputs.confirmPassword")}
            rules={[{ required: true }]}
            PasswordStrengthPopup={<PasswordStrengthPopup currentPasswordStrength={currentPasswordStrength} />}
            onChange={(e: ChangeEvent<HTMLInputElement>) => handleConfirmPasswordChange(e)}
          />
        </Col>
      </Row>
      <Row className="margin-top-100">
        <Col>
          <Form.Item name="newsletter" valuePropName="checked" rules={[{ required: false }]}>
            <Checkbox>{t("confirm.inputs.newsletter")}</Checkbox>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
